import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { EmailLogsModel } from "./email-logs-data-model";

export class EmailLogsParams extends GridPostParams { }

export class EmailLogsGridModel extends EmailLogsModel { }

export class EmailLogsListingModel extends GridModel<EmailLogsGridModel> { }